module.exports = __webpack_public_path__ + "img/xls.b81a30ad.svg";